const mapStateToProps = state => 
     ({
        data: state.certificacionDeAfiliacionAPartidoPolitico.data,
    });

export default mapStateToProps;
